import { Box, Card, CardContent, Typography } from "@mui/material";
import React from "react";

export const StatCard = ({
  title,
  value,
  Icon,
  color,
  background = "#f9fafc",
  textColor = "#000",
}) => (
  <Card
    sx={{
      minWidth: 220,
      borderRadius: 3,
      boxShadow: 3,
      background: background,
      color: textColor, // Couleur du texte
    }}>
    <CardContent>
      <Box display="flex" alignItems="center" gap={2}>
        <Icon fontSize="large" sx={{ color: textColor }} />
        <Box>
          <Typography variant="subtitle2" color="inherit">
            {title}
          </Typography>
          <Typography variant="h5" fontWeight="bold" color="inherit">
            {value}
          </Typography>
        </Box>
      </Box>
    </CardContent>
  </Card>
);
